import { Link } from "react-router-dom";
import "./Services.css";
import IconAndroid from "../../assets/icons/tech/android.svg";
import IconAngular from "../../assets/icons/tech/angularjs.svg";
import IconApple from "../../assets/icons/tech/apple.svg";
import IconElasticSearch from "../../assets/icons/tech/elasticsearch.svg";
import IconExpress from "../../assets/icons/tech/express.svg";
import IconFlutter from "../../assets/icons/tech/flutter.svg";
import IconGemini from "../../assets/icons/tech/gemini.svg";
import IconGPT from "../../assets/icons/tech/gpt.svg";
import IconGraphQL from "../../assets/icons/tech/graphql.svg";
import IconLLMA from "../../assets/icons/tech/llama.svg";
import IconNest from "../../assets/icons/tech/nestjs.svg";
import IconNode from "../../assets/icons/tech/nodejs.svg";
import IconReactNative from "../../assets/icons/tech/react-native.svg";
import IconReact from "../../assets/icons/tech/reactjs.svg";
import IconVue from "../../assets/icons/tech/vuejs.svg";

function Services() {
  return (
    <>
      <section className="wrapper bg-light services" id="services">
        <div className="container">
          <div className="row text-center">
            <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              <h2 className="fs-16 text-uppercase text-muted mb-3">
                What We Do
              </h2>
              <h3 className="display-4 mb-4 px-xl-10">
                End-to-end engineering for products that matter.
              </h3>
              <p className="lead text-muted mb-10">
                One senior team for strategy, design, engineering and AI — so
                you ship faster without juggling vendors.
              </p>
            </div>
          </div>
          <div className="position-relative">
            <div
              className="shape rounded-circle bg-soft-blue rellax w-16 h-16"
              style={{ bottom: "-0.5rem", right: "-2.2rem", zIndex: 0 }}
            />
            <div
              className="shape bg-dot primary rellax w-16 h-17"
              style={{ top: "-0.5rem", left: "-2.5rem", zIndex: 0 }}
            />
            <div
              className="row gx-md-5 gy-5 text-center services"
            >
              <div className="col-md-6" id="web-applications">
                <Link to="/web-applications" className="card-link">
                  <div className="card shadow-lg">
                    <div className="card-body">
                      <h4>Web Applications</h4>
                      <p className="mb-2">
                        Build responsive, secure, and scalable web applications tailored to your business needs. 
                        We create modern, user-friendly interfaces that work seamlessly across all devices.
                      </p>
                      <div className="mb-3">
                        <img
                          src={IconReact}
                          className="icon-svg icon-svg-sm text-yellow m-1 p-1"
                          alt="React JS"
                        />
                        <img
                          src={IconAngular}
                          className="icon-svg icon-svg-sm text-yellow m-1 p-1"
                          alt="Angular JS"
                        />
                        <img
                          src={IconVue}
                          className="icon-svg icon-svg-sm text-yellow m-1 p-1"
                          alt="Vue JS"
                        />
                        <img
                          src={IconNode}
                          className="icon-svg icon-svg-sm text-yellow m-1 p-1"
                          alt="Node JS"
                        />
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
              
              <div className="col-md-6" id="backend-api-dev">
                <Link to="/backend-api-development" className="card-link">
                  <div className="card shadow-lg">
                    <div className="card-body">
                      <h4>Backend API Development</h4>
                      <p className="mb-2">
                        Robust REST APIs and cloud-based backend systems designed for performance and scalability.
                        Build extensible back-end solutions for mobile, web and IoT that grow with your business.
                      </p>
                      <div className="mb-3">
                        <img
                          src={IconNode}
                          className="icon-svg icon-svg-sm text-yellow m-1 p-1"
                          alt="Node JS"
                        />
                        <img
                          src={IconExpress}
                          className="icon-svg icon-svg-sm text-yellow m-1 p-1"
                          alt="Express JS"
                        />
                        <img
                          src={IconNest}
                          className="icon-svg icon-svg-sm text-yellow m-1 p-1"
                          alt="Nest JS"
                        />
                        <img
                          src={IconGraphQL}
                          className="icon-svg icon-svg-sm text-yellow m-1 p-1"
                          alt="GraphQL"
                        />
                        <img
                          src={IconElasticSearch}
                          className="icon-svg icon-svg-sm text-yellow m-1 p-1"
                          alt="Elastic Search"
                        />
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
              
              <div className="col-md-6" id="mobile-applications">
                <Link to="/mobile-applications" className="card-link">
                  <div className="card shadow-lg">
                    <div className="card-body">
                      <h4>Mobile Applications</h4>
                      <p className="mb-2">
                        Native and cross-platform applications for Android and iOS with seamless user experiences.
                        We deliver high-performance mobile apps that engage your users and drive business growth.
                      </p>
                      <div className="mb-3">
                        <img
                          src={IconFlutter}
                          className="icon-svg icon-svg-sm text-yellow m-1 p-1"
                          alt="Flutter"
                        />
                        <img
                          src={IconAndroid}
                          className="icon-svg icon-svg-sm text-yellow m-1 p-1"
                          alt="Android"
                        />
                        <img
                          src={IconApple}
                          className="icon-svg icon-svg-sm text-yellow m-1 p-1"
                          alt="iOS"
                        />
                        <img
                          src={IconReactNative}
                          className="icon-svg icon-svg-sm text-yellow m-1 p-1"
                          alt="React Native"
                        />
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
              
              <div className="col-md-6" id="mvp-development">
                <Link to="/mvp-development" className="card-link">
                  <div className="card shadow-lg">
                    <div className="card-body">
                      <h4>MVP Development Services</h4>
                      <p className="mb-2">
                        Turn an idea into a launch-ready product in weeks. We scope ruthlessly,
                        build on a scalable foundation and help you validate with real users.
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
              
              <div className="col-md-6" id="generative-ai">
                <Link to="/generative-ai" className="card-link">
                  <div className="card shadow-lg">
                    <div className="card-body">
                      <h4>Generative AI Development</h4>
                      <p className="mb-2">
                        LLM-powered agents, chatbots, knowledge assistants and
                        automation built on GPT, Claude, Gemini and Llama —
                        integrated securely with your data and tools.
                      </p>
                      <div className="mb-3">
                        <img
                          src={IconGPT}
                          className="icon-svg icon-svg-sm text-yellow m-1 p-1"
                          alt="Chat GPT"
                        />
                        <img
                          src={IconGemini}
                          className="icon-svg icon-svg-sm text-yellow m-1 p-1"
                          alt="Google Gemini"
                        />
                        <img
                          src={IconLLMA}
                          className="icon-svg icon-svg-sm text-yellow m-1 p-1"
                          alt="Large Language Model Meta AI"
                        />
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Services;
